var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.acceptsCashOnDelivery)?_c('span',{staticClass:"cash-on-delivery-tag"},[_vm._v("Pago contra entrega")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }